<template>
  <div class="my-6 pb-1 shadow rounded">
    <div class="p-5 flex justify-between bg-gray-100 leading-none items-center group">
      <div class="flex items-center">
        <div
          class="text-green-400 lg:text-green-300 group-hover:text-green-400 text-xl handle cursor-move"
        >
          <font-awesome-icon icon="grip-vertical"></font-awesome-icon>
        </div>
        <div class="font-medium ml-4 mr-2">
          <span class="text-gray-400" v-if="!category.title">Kein Titel festgelegt</span>
          <span>{{category.title}}</span>
        </div>
        <button
          @click="editCategory"
          class="text-sm text-gray-800 hover:text-gray-600 lg:invisible group-hover:visible"
        >
          <font-awesome-icon :icon="['fad', 'edit']"></font-awesome-icon>
        </button>
      </div>

      <basic-popover v-if="category.defaultContingent" v-slot="{ refine, open }">
        <div @mouseover="refine(true)" @mouseleave="refine(false)" class="relative">
          <button class="flex text-sm text-gray-800 focus:outline-none" @click="editContingent">
            <div class="mr-2 border-b border-gray-300 pb-1">
              <span class="font-semibold">{{category.defaultContingent.available}}</span>
              / {{category.defaultContingent.count}}
              <span
                class="hidden sm:inline-block"
              >Tickets Verfügbar</span>
            </div>
          </button>

          <div v-show="open" class="pt-2 mr-6 right-0 absolute w-60">
            <div class="bg-white rounded shadow p-4 border">
              <div class="grid grid-cols-3 gap-2 text-sm">
                <div class="col-span-2">Kontingent:</div>
                <div>{{category.defaultContingent.count}}</div>
                <div class="col-span-2">Verkauft:</div>
                <div>{{category.defaultContingent.count - category.defaultContingent.available}}</div>
                <div class="col-span-2">Im Warenkorb:</div>
                <div>{{category.defaultContingent.reserved}}</div>
              </div>

              <basic-button
                class="mt-4 w-full"
                button-class="w-full justify-center"
                color="white"
                leading-icon="edit"
                @click="editContingent"
              >Ändern</basic-button>
            </div>
          </div>
        </div>
      </basic-popover>
    </div>

    <slot />
  </div>
</template>

<script>
import EditCategoryModal from "@/components/modals/EditCategoryModal";
import DeleteConfirmationModal from "@/components/modals/DeleteConfirmationModal";
import EditContingentModal from "@/components/modals/EditContingentModal";
import BasicPopover from "@/components/basic/Popover";

import categoryClient from "@/api/central/categories";

export default {
  props: ["categoryProp", "reloadEvent"],
  components: { BasicPopover },
  data() {
    return {
      category: this.categoryProp
    };
  },
  methods: {
    editCategory(category) {
      this.$modal.show(EditCategoryModal, {
        categoryProp: this.category,
        destroyFunc: this.destroyModal,
        editContingentFunc: this.editContingent
      });
    },
    editContingent() {
      this.$modal.show(EditContingentModal, {
        contingentProp: this.category.defaultContingent
      });
    },
    destroyModal() {
      this.$modal.show(DeleteConfirmationModal, {
        destroyFunc: this.destroy,
        header: `${this.category.title || "Kategorie"} wirklich löschen?`
      });
    },
    async destroy() {
      // Test if category was already saved on server if yes try to delete on server first
      this.category.id &&
        (await categoryClient.destroy(this.category.id).catch(error => {
          this.$toasted.global.error();
          throw error;
        }));

      this.$toasted.global.success();
      this.$emit("destroyed");

      return this.$store.dispatch("editor/refresh");
    }
  }
};
</script>